import React, { memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import selectedBg from "../../assets/svgs/sb.svg";
import Bg from "../../assets/svgs/menu_bg.svg";
import "./sub-menu.scss";
import Lottie from "lottie-react";
import horoscope from "../../assets/lotties/horoscope.json";
import compatiblity from "../../assets/lotties/compatiblity.json";
import video from "../../assets/lotties/video.json";
import astro from "../../assets/lotties/astrologer chat  call.json";
import games from "../../assets/lotties/games.json";

function SubMenu({ handleRest }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="sub-menu-container">
      <div
        className="menuoptions"
        onClick={() => {
          if (handleRest) {
            handleRest();
          }
          if (location.pathname === "/horoscope") {
            window.location.reload();
          } else {
            navigate("/horoscope");
          }
        }}
      >
        <div
          className="bg-menus"
          style={{
            backgroundImage:
              location.pathname === "/horoscope"
                ? `url(${selectedBg})`
                : `url(${Bg})`,
          }}
        >
          <Lottie
            animationData={horoscope}
            className="inside-bg"
            alt="Horoscope"
            loop
            autoplay
          />
        </div>
        <h2>Horoscope</h2>
      </div>

      <div
        className="menuoptions"
        onClick={() => {
          if (handleRest) {
            handleRest();
          }
          if (location.pathname === "/compactibility") {
            window.location.reload();
          } else {
            navigate("/compactibility");
          }
        }}
      >
        <div
          className="bg-menus"
          style={{
            backgroundImage:
              location.pathname === "/compactibility"
                ? `url(${selectedBg})`
                : `url(${Bg})`,
          }}
        >
          <Lottie
            animationData={compatiblity}
            className="compact-bg"
            alt="Compatibility"
            loop
            autoplay
          />
        </div>
        <h2>Compatibility</h2>
      </div>
      {/* <div
        className="menuoptions"
        onClick={() => {
          if (handleRest) {
            handleRest();
          }
          navigate("/videos");
        }}
      >
        <div
          className="bg-menus"
          style={{
            backgroundImage:
              location.pathname === "/videos"
                ? `url(${selectedBg})`
                : `url(${Bg})`,
          }}
        >
          <Lottie
            animationData={video}
            className="video-bg"
            alt="Video"
            loop
            autoplay
          />
        </div>
        <h2>Predictions Videos</h2>
      </div> */}
      <div
        className="menuoptions"
        onClick={() => {
          if (handleRest) {
            handleRest();
          }
          navigate("/consult-astrology");
        }}
      >
        <div
          className="bg-menus"
          style={{
            backgroundImage:
              location.pathname === "/consult-astrology"
                ? `url(${selectedBg})`
                : `url(${Bg})`,
          }}
        >
          <Lottie
            animationData={astro}
            className="astro-bg"
            alt="Astro"
            loop
            autoplay
          />
        </div>
        <h2>Consult with Astrologers</h2>
      </div>
      <div
        className="menuoptions games-div"
        onClick={() => {
          if (handleRest) {
            handleRest();
          }
          navigate("/games");
        }}
      >
        <div
          className="bg-menus"
          style={{
            backgroundImage:
              location.pathname === "/games"
                ? `url(${selectedBg})`
                : `url(${Bg})`,
          }}
        >
          <Lottie
            animationData={games}
            className="games-bg"
            alt="Games"
            loop
            autoplay
          />
        </div>
        <h2>Games</h2>
      </div>
    </div>
  );
}

export default memo(SubMenu);
